<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="业主姓名" prop="ownerUserName" style="width: 80%">
                <el-input
                  v-model="searchForm.ownerUserName"
                  placeholder="请输入业主姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="业主号码" prop="ownerPhone" style="width: 80%">
                <el-input
                  v-model="searchForm.ownerPhone"
                  placeholder="请输入业主手机号码"
                ></el-input>
              </el-form-item>
            </el-col>   
            <el-col :span="8">
              <el-form-item label="访客姓名" prop="visitorUserName" style="width: 80%">
                <el-input
                  v-model="searchForm.visitorUserName"
                  placeholder="请输入访客姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="访客号码" prop="visitorPhone" style="width: 80%">
                <el-input
                  v-model="searchForm.visitorPhone"
                  placeholder="请输入访客手机号码"
                ></el-input>
              </el-form-item>
            </el-col>                       
            <el-col :span="8">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px"></div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="ownerUserName" label="业主姓名" align="center">
        </el-table-column>
        <el-table-column prop="ownerPhone" label="业主手机号" align="center">
        </el-table-column>        
        <el-table-column prop="visitorUserName" label="访客姓名" align="center">
        </el-table-column>
        <el-table-column prop="visitorPhone" label="访客手机号码" align="center">
        </el-table-column>
        <el-table-column prop="subscribeTime" label="预约来访时间" align="center">
        </el-table-column>    
        <el-table-column prop="reason" label="预约来访原因" align="center">
        </el-table-column>   
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import reg from '../../utils/reg'
export default {
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      isShowloading:false,
      searchForm: {
        visitorPhone: "",
        visitorUserName:'',
        ownerPhone:'',
        ownerUserName:'',
      },
      pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },    
    onLoad(ind) {
      if(ind == 1){
        this.currentPage = 1
      }
      var data = {
        current: this.currentPage,
        size: this.pageSize,
        ...this.searchForm
      }
      this.$Apis.zlbVisitorList(data).then(res=>{
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
  },
};
</script>

<style>
</style>